import { render, staticRenderFns } from "./Inbounds.vue?vue&type=template&id=037416b9&scoped=true&"
import script from "./Inbounds.vue?vue&type=script&lang=js&"
export * from "./Inbounds.vue?vue&type=script&lang=js&"
import style0 from "./Inbounds.vue?vue&type=style&index=0&id=037416b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037416b9",
  null
  
)

export default component.exports